/*
  aness-pdp-gallery.js — original, minimal, scoped helper for the PDP gallery.
  No external dependencies. Works alongside the native gallery (does not modify
  or replace it). On MOBILE only, the native <slideshow-slides> scroller is
  forced into a horizontal swipe by CSS (aness-overrides.css section 27). This
  script renders a premium SEGMENTED progress bar (one segment per slide) at the
  bottom-centre that follows the horizontal scroll. The native counter is hidden
  on mobile by CSS to avoid duplicates. Loaded once from the Aness Product Tabs
  section (always present on the PDP).
*/
(function () {
  function initOne(media) {
    var track = media.querySelector('slideshow-slides');
    if (!track || track._anessProgress) return;

    var count = track.children.length;
    if (count < 2) return; // single image: no indicator needed

    track._anessProgress = true;

    var bar = document.createElement('div');
    bar.className = 'aness-pdp-gallery-progress';
    bar.setAttribute('aria-hidden', 'true');

    var segs = [];
    for (var i = 0; i < count; i++) {
      var seg = document.createElement('span');
      seg.className = 'aness-pdp-gallery-progress__seg';
      bar.appendChild(seg);
      segs.push(seg);
    }
    media.appendChild(bar);

    function update() {
      if (window.matchMedia('(min-width: 750px)').matches) return;
      var w = track.clientWidth || 1;
      var idx = Math.round(track.scrollLeft / w);
      if (idx < 0) idx = 0;
      if (idx > count - 1) idx = count - 1;
      for (var i = 0; i < segs.length; i++) {
        if (i === idx) {
          segs[i].classList.add('is-active');
        } else {
          segs[i].classList.remove('is-active');
        }
      }
    }

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    var medias = document.querySelectorAll('main[data-template^="product"] .product-information__media');
    Array.prototype.forEach.call(medias, initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
